import { Pipe, PipeTransform } from "@angular/core";
import { DecimalPipe } from "@angular/common";

@Pipe({
    name: "priceFormat",
    standalone: false
})
export class PriceFormatPipe implements PipeTransform {
	constructor(private numberPipe: DecimalPipe) {}

	transform(value: any): string {
		return this.numberPipe.transform(value, "0.0-2");
	}
}
